import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LanguageIcon from '@material-ui/icons/Language';

import logoGaia from '../../../assets/images/bgLogin.png';
import { LoginForm } from './Form';
import useStyles from './styles';

const Login = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <div className={classes.logoWrapper}>
          <img className={classes.logo} src={logoGaia} alt='Gaia Logo' />
        </div>
        <Typography variant='h5' className={classes.title}>
          Gaia System
        </Typography>
        <Typography variant='body2' className={classes.subtitle}>
          Sistema de gerenciamento
        </Typography>
        <Typography variant='body2' className={classes.byline}>
          Desenvolvido por <strong className={classes.flai}>FLAI</strong>
        </Typography>
        <div className={classes.icons}>
          <FacebookIcon className={classes.icon} />
          <InstagramIcon className={classes.icon} />
          <LanguageIcon className={classes.icon} />
        </div>
        <LoginForm />
      </Card>
    </div>
  );
};

export default Login;
